import Common from './Common.js';
import ScrollV from './ScrollV.js';
import Navi from './Navigation.js';
import MouseWheel from './MouseWheel.js';
import WinResize from './WinResize.js';

class App{
    constructor(){
        this.comm = Common.instance;
        this.wheel = MouseWheel.instance;
        this.navi = Navi.instance;
        this.winRe = WinResize.instance;
        this.scrV = new ScrollV();
    }

    /** start of Public */
    init(_option){
        this.comm.init(_option);
        this.scrV.init();
        this.navi.init();
        this.wheel.init();
        this.winRe.init();

        return this;
    }

    go(_d1, _d2){
        this.navi.go(_d1, _d2);
        return this;
    }

    next(){
        this.navi.nextprev(1);
    }

    prev(){
        this.navi.nextprev(-1);
    }

    useMouseWheel(_bool){
        this.comm.option.useMouseWheel = _bool;
    }

    getDepth(){
        return this.comm.depth;
    }

    /** end of Public   */
}

window.fullscreen = new App();


// WEBPACK FOOTER //
// ./app.js